import { Skeleton } from '#/shared/ui/skeleton'

const SKELETON_ROW_COUNT = 3

function CarrierColSkeleton() {
  return (
    <div className="min-w-0 flex-1">
      <div className="flex flex-col gap-1.5">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-25" />
          <Skeleton className="h-5 w-22 rounded-full" />
        </div>
        <Skeleton className="h-3.5 w-50" />
        <Skeleton className="h-3.5 w-65" />
        <Skeleton className="h-3.5 w-40" />
        <div className="flex items-center gap-3">
          <Skeleton className="h-3.5 w-25" />
          <Skeleton className="h-3.5 w-20" />
        </div>
      </div>
    </div>
  )
}

function DateColSkeleton() {
  return (
    <div className="flex w-37.5 shrink-0 flex-col gap-2">
      <Skeleton className="h-4 w-20" />
      <Skeleton className="h-4 w-22" />
    </div>
  )
}

function PriceColSkeleton() {
  return (
    <div className="flex w-27.5 shrink-0 flex-col gap-1">
      <Skeleton className="h-5 w-12" />
      <Skeleton className="h-5 w-18 rounded-md" />
      <Skeleton className="h-3 w-12" />
    </div>
  )
}

function ActionColSkeleton() {
  return (
    <div className="flex w-45 shrink-0 flex-col gap-2">
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
      <Skeleton className="h-8 w-full" />
    </div>
  )
}

function RequestRowSkeleton() {
  return (
    <article className="flex flex-col gap-3 border-b border-gray-200 px-5 py-5 last:border-b-0">
      <div className="flex items-start gap-6">
        <CarrierColSkeleton />
        <DateColSkeleton />
        <PriceColSkeleton />
        <ActionColSkeleton />
      </div>
    </article>
  )
}

function FilterBarSkeleton() {
  return (
    <header className="flex h-10 items-center bg-warm-25 px-5">
      <Skeleton className="h-4 w-30" />
    </header>
  )
}

export function CarrierRequestsListSkeleton() {
  return (
    <div className="flex flex-col">
      <FilterBarSkeleton />
      {Array.from({ length: SKELETON_ROW_COUNT }).map((_, i) => (
        <RequestRowSkeleton key={i} />
      ))}
    </div>
  )
}
